import { LinkPseudoButton, IconExpand } from '@ui/src';
import { ColumnHeadTypes } from './types';

import cn from './column.module.css';

const ColumnHead = ({ title, path, linkIsVisible }: ColumnHeadTypes) => (
  <div className={cn.columnTop}>
    <p className={cn.columnTitle}>{title}</p>
    {path && linkIsVisible && (
      <LinkPseudoButton
        text="Add"
        icon={<IconExpand className={cn.addItemIcon} />}
        path={path}
      />
    )}
  </div>
);

export default ColumnHead;
